import { render, staticRenderFns } from "./OpenIdCreate.vue?vue&type=template&id=aaf96158"
import script from "./OpenIdCreate.vue?vue&type=script&lang=js"
export * from "./OpenIdCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports